import { ChatAPI } from "../api";
export class Chat {
  constructor(props) {
    for (const [key, value] of Object.entries(props)) {
      this[key] = value;
    }
  }
  static async createChat(payload) {
    const { data } = await ChatAPI.createChat(payload);
    return new Chat(data.result);
  }
}
